import React, { lazy, Suspense } from 'react';
import clsx from 'clsx';
import { observer } from 'mobx-react';
import { Helmet } from 'react-helmet';

import Footer from 'src/components/Footer';
import Loading from 'src/components/Loading';
import AboutUsVM from './viewModel';

import styles from './styles.module.scss';

const Editor = lazy(() => import('src/components/Editor'));

@observer
class AboutUs extends React.Component {
  constructor() {
    super();
    this.vm = new AboutUsVM();
  }

  componentDidMount() {
    this.vm.didMount();
  }

  render() {
    return (
      <>
        <Helmet>
          <title>關於我們</title>
          <meta
            name="description"
            content="這是一個由拼圖喵中途之家開發的服務平台，希望促進貓咪出養及認養資訊的流通，讓大家可以開開心心的做貓家人。"
          />
          <link rel="canonical" href="https://meowohana.com/about-us" />
        </Helmet>

        {this.vm.isPageLoading
          ? <Loading />
          : (
            <div className={styles.main}>
              <div className={styles.box}>
                {this.vm.isLoaded && (
                <div className={clsx(styles.editorBox, 'editor-shell')}>
                  <Suspense>
                    <Editor
                      initialEditorState={this.vm.content}
                      onChange={() => {}}
                      editable={false}
                    />
                  </Suspense>
                </div>
                ) }
              </div>
            </div>
          )}
      </>
    );
  }
}

AboutUs.propTypes = {

};

export default AboutUs;
